"use client";

import {
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Button } from "@/ui/Button";
import { useTranslation } from "react-i18next";
import { MdGpsFixed } from "react-icons/md";

const SearchingForGrosLoading = () => {
  const { t } = useTranslation("register");

  return (
    <>
      <DialogHeader className="sm:text-right">
        <DialogTitle className="text-foreground text-center">
          {t("location_verification")}
        </DialogTitle>
      </DialogHeader>

      <div className="my-4">
        <span className="animate-ping mx-auto h-4 w-4 grid place-items-center rounded-full bg-muted-foreground opacity-75 ">
          <MdGpsFixed className="text-[1rem]" />
        </span>
        <span className="text-muted-foreground text-center mt-4 block text-sm font-medium">
          {t("search_nearest_vendor")}
        </span>
      </div>

      <DialogFooter className="!flex-col-reverse">
        <Button isLoading={true} className="w-full">
          {t("continue_button")}
        </Button>
      </DialogFooter>
    </>
  );
};

export default SearchingForGrosLoading;
